import MixinBase from './mixin-base.js'

export default {
  mixins: [MixinBase],
  props: {
    binary: { //используем только у cool pump and valve
      type: Boolean,
      default: () => false,
    }
  },
  methods: {
    stateSwitch(states, value) {
      switch (this.value) {
        case true:
          states[0] = "visible"
          break;
        case false:
          states[1] = "visible"
          break;
        case null:
          states[10] = "visible"
          break;
        default:
          states[this.value] = "visible";
          break;
      }
    }
  },
  computed: {
    fState: function () {
      let states = ["hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden"];
      this.stateSwitch(states, this.value)
      return states;
    }
  },
}      